
import React from 'react';
import { ChevronUp, ChevronDown, ChevronsUpDown } from 'lucide-react';

export type SortDirection = 'asc' | 'desc' | null;

interface SortableHeaderProps {
  children: React.ReactNode;
  column: string;
  currentSort: {
    column: string | null;
    direction: SortDirection;
  };
  onSort: (column: string) => void;
  className?: string;
}

export function SortableHeader({ 
  children, 
  column, 
  currentSort, 
  onSort, 
  className = "" 
}: SortableHeaderProps) {
  const isActive = currentSort.column === column;
  const direction = isActive ? currentSort.direction : null;

  const getSortIcon = () => {
    if (!isActive || direction === null) {
      return <ChevronsUpDown className="h-4 w-4 text-muted-foreground" />;
    }
    return direction === 'asc' ? 
      <ChevronUp className="h-4 w-4 text-foreground" /> : 
      <ChevronDown className="h-4 w-4 text-foreground" />;
  };

  const handleClick = () => {
    onSort(column);
  };

  return (
    <button
      className={`
        flex items-center justify-between w-full text-left hover:bg-muted/50 
        transition-colors duration-150 px-4 py-0.5 cursor-pointer group
        ${isActive ? 'bg-muted/30' : ''}
        ${className}
      `}
      onClick={handleClick}
      type="button"
    >
      <span className={`
        text-xs font-medium text-muted-foreground uppercase tracking-wider
        ${isActive ? 'text-foreground' : ''}
      `}>
        {children}
      </span>
      <span className="ml-2 opacity-60 group-hover:opacity-100 transition-opacity">
        {getSortIcon()}
      </span>
    </button>
  );
}
